import { getApp, getApps, initializeApp } from "firebase/app";
import { getMessaging } from "firebase/messaging";

const firebaseConfig = {
  apiKey: "AIzaSyDu7AjVlr3i9gs5cLs7LjxmtJB6QBYuzWE",
  authDomain: "playmatez-38cf6.firebaseapp.com",
  databaseURL: "https://playmatez-38cf6-default-rtdb.firebaseio.com",
  projectId: "playmatez-38cf6",
  storageBucket: "playmatez-38cf6.firebasestorage.app",
  messagingSenderId: "109442322016",
  appId: "1:109442322016:web:d0915b6151d40590933d05",
  measurementId: "G-4LB8BQ466Q",
};

// ✅ Prevent duplicate initialization
const app = getApps()?.length === 0 ? initializeApp(firebaseConfig) : getApp();

// Push messaging needs a secure context (https or localhost) plus service
// worker + Push API support. On plain http (e.g. http://192.168.x.x during
// development) or browsers like older iOS Safari, getMessaging() throws and
// would crash the whole app — so messaging is null there instead.
const canUseMessaging = () =>
  typeof window !== "undefined" &&
  window.isSecureContext &&
  "serviceWorker" in navigator &&
  "Notification" in window &&
  "PushManager" in window;

export const messaging = (() => {
  if (!canUseMessaging()) return null;
  try {
    return getMessaging(app);
  } catch (error) {
    console.warn("Firebase messaging unavailable:", error?.message);
    return null;
  }
})();
